import * as React from "react";
import PlatformCard from "../platform/PlatformCard";
import {
  marketingColors,
  marketingShadow,
  marketingRadius,
  marketingFonts,
} from "../tickitMarketingTheme";

/** Light-only marketing card — platform `.card` styling */
export default function MarketingCard({ title, headerAction, children, sx = {}, contentSx = {}, flush }) {
  return (
    <PlatformCard
      title={title}
      headerAction={headerAction}
      flush={flush}
      sx={{
        backgroundColor: marketingColors.surface,
        borderRadius: marketingRadius.lg,
        border: `1px solid ${marketingColors.border}`,
        boxShadow: marketingShadow.card,
        mb: 2.25,
        "& .MuiTypography-root": {
          fontFamily: marketingFonts.display,
          color: marketingColors.text,
        },
        ...sx,
      }}
      contentSx={contentSx}
    >
      {children}
    </PlatformCard>
  );
}
